// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3eCbI","text":"SelectPayment_text__1M3V7","title":"SelectPayment_title__3f_2i","btn":"SelectPayment_btn__1I59W"};